import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49f62821")

_pushScopeId("data-v-49f62821")
const _hoisted_1 = { class: "account_manage_module_hd flex_space_center" }
const _hoisted_2 = { class: "flex_start_center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.viewModel.logo,
        class: "logo_icon",
        alt: ""
      }, null, 8, ["src"]),
      _createVNode("span", null, _toDisplayString(_ctx.viewModel.title) + "-账号管理", 1)
    ]),
    _createVNode("div", {
      class: "close_btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
    })
  ]))
})